import {
  AVAILABLE_SIZES,
  CLASSIC,
  CUSTOM_SIZE,
  PERFECT_FIT,
  POPULAR_SIZES,
  SQUARE,
} from "@/utils/constants";

export const SIZE_OPTIONS = [PERFECT_FIT, POPULAR_SIZES, CUSTOM_SIZE];
export const SIZE_OPTIONS_HD = [AVAILABLE_SIZES];

export const POPULAR_OPTIONS = [CLASSIC, SQUARE];
